import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import CheckIcon from "src/core/assets/images/icons/check.svg?react";
import { StakeholderCard } from "src/core/components/folder/stakeholders/StakeholderCard";
import { Button } from "src/core/components/ui/button";
import { MappedStakeholder } from "src/core/constants/folder";
import { IRiskOption } from "src/core/constants/options";

type CurrentStakeholderCardProps = {
  stakeholder: MappedStakeholder;
  countryWithRiskOptions: IRiskOption[];
  customerCompanyNames?: string[];
  customerCompaniesLoading?: boolean;
  showReferenceButton?: boolean;
  isReferenceSelected?: boolean;
  onSelectReference?: () => void;
};

export const CurrentStakeholderCard = ({
  stakeholder,
  countryWithRiskOptions,
  customerCompanyNames = [],
  customerCompaniesLoading = false,
  showReferenceButton = false,
  isReferenceSelected = false,
  onSelectReference,
}: CurrentStakeholderCardProps) => {
  const { t } = useTranslation();

  const stakeholderDisplayData = useMemo(
    () => ({
      firstName: stakeholder.firstName,
      lastName: stakeholder.lastName,
      title: stakeholder.title,
      birthName: stakeholder.birthName,
      birthDate: stakeholder.birthDate,
      citizenshipCountryCode: stakeholder.citizenshipCountryCode,
      residenceCountryCode: stakeholder.residenceCountryCode,
      birthCountryCode: stakeholder.birthCountryCode,
      pepStatus: stakeholder.pepStatus,
      sanctionStatus: stakeholder.sanctionStatus,
    }),
    [stakeholder]
  );

  return (
    <div className="w-[340px] shrink-0">
      <div className="mb-10 relative flex items-center justify-center h-20">
        {t("stakeholders.duplicateCheck.modal.currentStakeholder")}
      </div>

      <StakeholderCard
        data={stakeholderDisplayData}
        countryWithRiskOptions={countryWithRiskOptions}
        customerCompanyNames={customerCompanyNames}
        customerCompaniesLoading={customerCompaniesLoading}
      />

      {showReferenceButton && (
        <div className="flex flex-col items-center justify-center w-full mt-10">
          <Button
            variant="button4"
            size="none"
            data-selected={isReferenceSelected}
            onClick={onSelectReference}
          >
            <div className="flex flex-row items-center gap-x-5 text-sm">
              <CheckIcon className="size-20" />
              {t("stakeholders.duplicateCheck.modal.form.referenceProfile")}
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};
